export default "__VITE_ASSET__CNfaOFRB__"